module.exports = __webpack_public_path__ + "static/praga-466ddc252be874ee7d46786a4923ba59.jpg";